import { useBranch } from "@/context/BranchContext";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// "current" = active branch, "all" = all branches combined (summed)
export function ScopeSelect({ value, onChange, testId }) {
  const { activeBranch } = useBranch();
  return (
    <div className="flex items-center gap-2">
      <Label className="text-xs uppercase tracking-widest text-zinc-500">Scope</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-60" data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="current">{activeBranch?.name || "This branch"}</SelectItem>
          <SelectItem value="all">All branches (combined)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

export const scopeParam = (scope) => (scope === "all" ? { branch_id: "all" } : {});
